import React from "react";

type User = {
  name: string;
  email: string;
  phone: string;
  productPermission: string;
  orderPermission: string;
  inventoryPermission: string;
  imageUrl: string;
};

type Props = {
  user: User;
};

export const UserCard: React.FC<Props> = ({ user }) => {
  return (
    <div className="flex items-start gap-4 rounded-lg border p-4 shadow-sm">
      <img src={user.imageUrl} alt={user.name} className="h-16 w-16 rounded-md object-cover" />
      <div className="flex-1">
        <div className="text-sm text-gray-500">Name</div>
        <div className="text-base font-semibold">{user.name}</div>

        <div className="mt-2 text-sm text-gray-500">Email ID</div>
        <div className="text-base text-orange-500">{user.email}</div>

        <div className="mt-2 text-sm text-gray-500">Phone Number</div>
        <div className="text-base">{user.phone}</div>

        <div className="mt-4 grid grid-cols-3 gap-4 text-sm">
          <div>
            <div className="text-gray-500">Product</div>
            <div>{user.productPermission}</div>
          </div>
          <div>
            <div className="text-gray-500">Order</div>
            <div>{user.orderPermission}</div>
          </div>
          <div>
            <div className="text-gray-500">Inventory</div>
            <div>{user.inventoryPermission}</div>
          </div>
        </div>
      </div>
      <button className="self-start rounded-md border px-3 py-1 text-sm hover:bg-gray-100">
        ✏️ Edit
      </button>
    </div>
  );
};
